<template>
  <div class="create-sticker-wrap">
    <el-card class="create-sticker-body">
      <!-- 顶部按钮区域 -->
      <el-row class="common-con-btns mb5">
        <el-col :span="24" class="mb10">
          <el-button size="small" type="primary" class="fresh-btn" @click="fresh">刷新</el-button>
          <el-button size="small" type="primary" class="fresh-btn" @click="showCreateSticker">创建批次</el-button>
        </el-col>
        </el-row>
        <el-form size="mini" inline>
            <el-form-item label="筛选">
                <el-select v-model="selects.platform_id" placeholder="所属平台" clearable>
                    <el-option
                        v-for="item in platformList"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="getSelects">筛选</el-button>
            </el-form-item>
        </el-form>
        <el-row class="common-con-btns mb5">
            <el-col :span="24">
            <el-alert>温馨提示：创建批次成功后，点击“生成”将会持续几分钟，当状态为“已生成”时，才可进行导出。“生成中”持续时间根据生成的数量确定，请几分钟以后在刷新该页面查看状态，请耐心等待！</el-alert>
            </el-col>
        </el-row>
      <!-- 表格区域 -->
      <el-table
        class="page-wrap"
        :data="dataList"
        ref="listTable"
        header-row-class-name="table-black-header"
        style="width: 100%"
      >
        <el-table-column label="批次编号" prop="id" align="center"></el-table-column>
        <el-table-column label="批次名" prop="batch_name" align="center"></el-table-column>
        <el-table-column label="所属平台" prop="platform_id" align="center">
          <template slot-scope="scope">
            {{ platformList.find(v => { return v.key == scope.row.platform_id }) ? platformList.find(v => { return v.key == scope.row.platform_id }).value : '' }}
          </template>
        </el-table-column>
        <el-table-column label="数量(个)" prop="num" align="center"></el-table-column>
        <el-table-column label="生成时间" prop="created_at" align="center"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">待生成</span>
            <span v-if="scope.row.status == 2">已生成</span>
            <span v-if="scope.row.status == 3">生成中</span>
            <span v-if="scope.row.status == 4">生成失败</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              v-if="scope.row.status == 1"
              @click="reCreate(scope.row)"
            >生成</el-button>
            <el-button
              type="text"
              size="mini"
              v-if="scope.row.status == 2&&scope.row.releases !=''"
              @click="exportSticker(scope.row.id,scope.row.releases)"
            >导出</el-button>

            <el-button
                    type="text"
                    size="mini"
                    v-if="scope.row.status == 2&&scope.row.releases !=''"
                    @click="toStatus(scope.row.id)"
            >查看状态统计</el-button>

            <el-button
              type="text"
              size="mini"
              class="cred"
              v-if="scope.row.status == 4"
              @click="reCreate(scope.row)"
            >重试</el-button>

            <el-button
                type="text"
                size="mini"
                v-if="scope.row.status == 2&&scope.row.releases !=''"
                @click="reExport(scope.row)"
            >重新生成Execl</el-button>
            <span v-if="scope.row.status == 3">-</span>
          </template>
        </el-table-column>
      </el-table>

      <!--页码信息-->
      <div class="ftc mt10">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="page.total"
          :page-size="page.pageSize"
          @current-change="currentPageChange"
        ></el-pagination>
      </div>

      <!-- 生成贴纸对话框 -->
      <el-dialog
        title="创建批次"
        :visible.sync="createStickerDialog.showDialog"
        :before-close="closeCreateStickerDialog"
        custom-class="create-sticker"
        width="30%"
      >
        <el-form
          label-width="80px"
          ref="setStickerForm"
          :model="createStickerDialog"
          :rules="createStickerDialog.rules"
        >
          <el-form-item label="批次名" prop="batch_name">
            <el-row>
              <el-col :span="22">
                <el-input v-model="createStickerDialog.batch_name"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="所属组织" prop="batch_name">
            <template>
                <el-radio-group v-model="createStickerDialog.pid">
                    <el-radio v-for="item in platformList" :key="item.key" :label="item.key">{{ item.value }}</el-radio>
                </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item label="数量" prop="num">
            <el-row :gutter="4">
              <el-col :span="18">
                <el-input v-model="createStickerDialog.num" @keyup.native="checkNumber"></el-input>
              </el-col>
              <el-col :span="4">
                <el-select v-model="createStickerDialog.unit" @change="checkNumber">
                  <el-option :value="1" label="万"></el-option>
                  <el-option :value="2" label="个"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="confirmCreateSticker">确 定</el-button>
          <el-button size="small" @click="closeCreateStickerDialog">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { stickerApi } from "@/api/sticker";
export default {
  data() {
    return {
        // 有权限的平台列表
        platformList: [],
        selects: {
            platform_id: '',
        },
      page: {
        currentPage: 1,
        pageSize: 50,
        total: 1
      },
      radio: '1',
      dataList: [],
      createStickerDialog: {
        pid: '',
        showDialog: false,
        batch_name: "",
        num: "",
        unit: 1, //1为万,2为个
        rules: {
          batch_name: [{ required: true, message: "请填写批次名", trigger: "blur" }],
          num: [{ required: true, message: "请填写生成数量", trigger: "blur" }],
          pid: [{ required: true, message: "请选择生成平台", trigger: "blur" }],
        }
      }
    };
  },
  created() {
    this.getPlatformPermission()
    this.getList();
  },
  methods: {
    // 获取有权限的平台列表
    getPlatformPermission() {
        this.$EpetJs.Common.ajax('get', stickerApi.getPlatformPermissionUrl).then(res => {
            if(res) {
                this.platformList = res.data.data || []
            }
        })
    },
    /**
     * 获取生成贴纸列表
     */
    getList() {
      const pam = {
        platform_id: this.selects.platform_id,
        page: this.page.currentPage,
        per_page: this.page.pageSize
      };
      this.$EpetJs.Common.get(stickerApi.getStickerLogsUrl, pam, {
        needLoading: true
      }).then(res => {
        if (res) {
          this.dataList = res.data.data;
          if (res.data.meta && res.data.meta.pagination) {
            this.page.total = res.data.meta.pagination.total;
          }
        }
      });
    },
    /**
     * 点击生成贴纸
     */
    showCreateSticker() {
      this.createStickerDialog.showDialog = true;
    },
    /**
     * 检测输入的数量
     */
    checkNumber() {
      if (this.createStickerDialog.unit == 1) {
        let value = this.createStickerDialog.num;
        value = value.replace(/[^\d.]/g, "");
        value = value.replace(/^\./g, "");
        if (value == "00") {
          value = "0.0";
        }
        value = value
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".");
        value = value.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, "$1$2.$3");
        this.createStickerDialog.num = value;
      } else {
        let value = this.createStickerDialog.num;
        value = value.replace(/[^\d]/g, "");
        value = value.replace(/^(0)*(\d+)*$/, "$2");
        this.createStickerDialog.num = value;
      }
    },
    /**
     * 确认生成贴纸
     */
    confirmCreateSticker() {
      this.$refs.setStickerForm.validate(valid => {
        if (valid) {
          let number =
            this.createStickerDialog.unit == 1
              ? this.createStickerDialog.num * 10000
              : this.createStickerDialog.num;
          if (number == 0) {
            this.$message.warning("请输入要创建的数量！");
            return false;
          }
          let title = this.createStickerDialog.unit == 1 ? "万个" : "个";
          this.$EpetJs.Common.confirm(
            "即将生成" +
              this.createStickerDialog.num +
              title +
              "贴纸码，确定吗？",
            "提示",
            {
              confirmButtonText: "生成",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
            .then(() => {
              const pam = {
                batch_name: this.createStickerDialog.batch_name,
                num: number.toString(),
                pid: this.createStickerDialog.pid
              };
              this.$EpetJs.Common.post(stickerApi.getStickerLogsUrl, pam).then(
                res => {
                  if (res) {
                    this.$message.success("批次创建成功！");
                    this.getList();
                    this.closeCreateStickerDialog();
                  }
                }
              );
            })
            .catch(() => {});
        }
      });
    },
    /**
     * 重试生成贴纸
     */
    reCreate(data) {
      const pam = {
        status: 3
      };
      this.$EpetJs.Common.put(
        stickerApi.getStickerLogsUrl + "/" + data.id,
        pam
      ).then(res => {
        if (res) {
          this.$message.success("贴纸生成请求成功！生成过程将持续几分钟，请在状态为‘已生成’后再进行导出！");
          this.getList();
          this.closeCreateStickerDialog();
        }
      });
    },
    reExport(data) {
      const pam = {
        debug: 1
      };
      this.$EpetJs.Common.get(
          stickerApi.getStickerLogsExportUrl + "/" + data.id,
          pam
      ).then(res => {
        if (res) {
          this.$message.success("正在重新生成Execl表格，请稍等！");
          this.getList();
          this.closeCreateStickerDialog();
        }
      });
    },
    /**'
     * 导出贴纸
     */
    exportSticker(id, releases) {
      if (releases) {
        const pam = {
          domain: releases
        };
        this.$EpetJs.Common.get(stickerApi.exportStickerUrl, pam).then(res => {
          if (res) {
            const url = res.data.data.url;
            window.location.href = url;
          }
        });
      } else {
        const url =
          stickerApi.getStickerLogsUrl +
          "/" +
          id +
          "?token=" +
          this.$store.state.userInfo.token;
        window.location.href = url;
      }
    },
    /**
     * 关闭生成贴纸对话框
     */
    closeCreateStickerDialog() {
      this.createStickerDialog.showDialog = false;
      this.createStickerDialog.batch_name = "";
      this.createStickerDialog.num = "";
      this.createStickerDialog.unit = 1;
      this.$refs.setStickerForm.clearValidate();
    },
    /**
     * 刷新
     */
    fresh() {
      EpetJs.Common.showLoading("刷新中", true);
      setTimeout(() => {
        this.getList();
      }, 500);
    },
    /**
     * 筛选
     */
     getSelects() {
      this.page.currentPage = 1;
      this.getList();
    },
    /**
     * 当前页改变
     */
    currentPageChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    /**
     * 查看状态统计
     */
    toStatus(id) {
      this.$router.push("/sticker/status/" + id);
    },
  }
};
</script>
<style lang="less">
.create-sticker-wrap {
  .create-sticker-body {
    min-height: calc(100vh - 60px);
    .cred {
      color: #f56c6c;
    }
  }
}
.create-sticker {
  min-width: 500px;
}
</style>
